import {
  faThumbsUp,
  faHeart,
  faHandHoldingHeart,
  faHandsClapping,
  faLightbulb,
  faFaceLaugh,
  faFaceSadTear,
} from '@fortawesome/free-solid-svg-icons';

/** LinkedIn-style reactions used across the feed. */
export const REACTIONS = [
  { type: 'like', label: 'Like', icon: faThumbsUp, color: '#0a66c2' },
  { type: 'love', label: 'Love', icon: faHeart, color: '#df704d' },
  { type: 'support', label: 'Support', icon: faHandHoldingHeart, color: '#bba9d1' },
  { type: 'clap', label: 'Clap', icon: faHandsClapping, color: '#6dae4f' },
  { type: 'insightful', label: 'Insightful', icon: faLightbulb, color: '#f5bb5c' },
  { type: 'funny', label: 'Funny', icon: faFaceLaugh, color: '#57c3b8' },
  { type: 'sad', label: 'Sad', icon: faFaceSadTear, color: '#7f90a8' },
];

export const REACTION_MAP = Object.fromEntries(REACTIONS.map((r) => [r.type, r]));

export const DEFAULT_REACTION = 'like';

export function getReaction(type) {
  return REACTION_MAP[type] || REACTION_MAP[DEFAULT_REACTION];
}

/** Top reaction types present in a who-liked list, ordered by frequency. */
export function getTopReactions(likedUsers = [], limit = 3) {
  const counts = {};
  likedUsers.forEach((u) => {
    const type = u.reaction_type || DEFAULT_REACTION;
    counts[type] = (counts[type] || 0) + 1;
  });
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([type]) => type);
}
